import { Button } from '@openx/components-core/lib/Button/Button.tsx';
import { useTranslation } from 'react-i18next';

interface AlertActionProps {
  showErrors: boolean;
  setShowErrors: (isError: boolean) => void;
}

export function AlertAction({ showErrors, setShowErrors }: AlertActionProps) {
  const { t } = useTranslation();

  const alertActionText = showErrors ? t('Hide Details') : t('See Details');

  return (
    <Button type="button" onClick={() => setShowErrors(!showErrors)} variant="text" color="error">
      {alertActionText}
    </Button>
  );
}
